import React, { useEffect, useState, useCallback, FunctionComponent } from 'react';
import { Toasts } from '../Toasts/Toasts';
import { Event } from '../../core/Manager';
import { IToast } from '../../core/Toast';
import { manager } from './utils';

interface Props {
  className?: string;
}

export const ToastManager: FunctionComponent<Props> = ({ className }) => {
  const [state, setState] = useState<IToast[]>([]);

  const onChange = useCallback(
    (toasts: IToast[]) => {
      setState([...toasts]);
    },
    [setState]
  );

  useEffect(() => {
    manager.on(Event.CHANGE, onChange);
    return () => manager.off(Event.CHANGE, onChange);
  }, [setState, onChange]);

  return <Toasts items={state} className={className} />;
};
